
import _ from 'lodash';
// `action` is aliased so the imported MobX annotation does not collide with
// the `action` constructor parameter used below.
import { observable, action as mobxAction } from 'mobx';
import { toDate } from 'core/utils';
import { PickTicketHeaderService } from 'application/pick-ticket/services';

class TasksCardStore {
    @observable accessor tasks = [];
    @observable accessor call = null;
    @observable accessor disableCheckboxes = false;
    constructor(rootStore,action) {

        this.rootStore = rootStore;
        this.call = action.fetchFunc;
        this.action = action;
        this.userRoles = rootStore.userStore.applicationUser.roles;
        this.setReminder();
    }

    @mobxAction.bound
    async fetchFunc(fetchFunc) {
        const response = await fetchFunc();
        const sortedResponse = _.orderBy(response.data.item, "date", "desc");

        const tasks = _.map(sortedResponse, (item) => {
            let isEnternal = item.facility && item.facility.facilityAreaOfCares.find(x => x.areaOfCare.abrv == "enteral");
            let isCoverageTypeAll = isEnternal && isEnternal.coverageType.abrv == "all";
            const deliveryDate = item.facilityScheduleDates.length > 0 && item.facilityScheduleDates.find(t=>t.facilityScheduleType && t.facilityScheduleType.abrv === 'delivery');
            return _.extend(item, {
                name: item.facility && item.facility.name + (item.areaOfCare ? ', ' + item.areaOfCare.name : '')  + (deliveryDate ? ' - [' + toDate(deliveryDate.date) + ']' : '') + (item.dateOfService && ' - [DOS: ' + toDate(item.dateOfService) + ']'),
                accRepName: item.accountRep ? item.accountRep.firstName + ' ' + item.accountRep.lastName : '',
                dateString: toDate(item.date),
                originalAccountRep: item.facility && item.facility.accountRep && item.facility.accountRepId != item.accountRepId ?
                    item.facility.accountRep.firstName + ' ' + item.facility.accountRep.lastName : null,
                originalIntakeRep: item.facility.intakeRep && item.facility.intakeRepId != item.intakeRepId ?
                    item.facility.intakeRep.firstName + ' ' + item.facility.intakeRep.lastName : null,
                originalPayorRep: item.facility.payorRep && item.facility.payorRepId != item.payorRepId ?
                    item.facility.payorRep.firstName + ' ' + item.facility.payorRep.lastName : null,
                originalDocumentRep: item.facility.documentRep && item.facility.documentRepId != item.documentRepId ?
                    item.facility.documentRep.firstName + ' ' + item.facility.documentRep.lastName : null,
                originalBillingRep: item.facility.billingRep && item.facility.billingRepId != item.billingRepId ?
                    item.facility.billingRep.firstName + ' ' + item.facility.billingRep.lastName : null,
                isCoverageTypeAll: isCoverageTypeAll,
            }); 
        });
        let grouped = _.groupBy(tasks, 'dateString');
        let sortedGroup = {};
        _.each(grouped, (val, key) => {
            sortedGroup[key]  = _.sortBy(val, i => i.name);
        });
        return sortedGroup;
    }

    @mobxAction.bound
    openFacilityEdit(id) {
        window.open(this.rootStore.routerStore.findRoute('master.app.main.facility.edit').pattern.replace(":id",id));
    }

    @mobxAction.bound
    openPickTicketEdit(facilityOrder, pickTicketHeaderId) {
        localStorage.setItem('refreshPickTicket', true);
        let route = facilityOrder.isNewFlow2 ? 'master.app.main.facility-order.pick-ticket-new-flow.list' : 'master.app.main.facility-order.pick-ticket.list';
        window.open(`${this.rootStore.routerStore
            .findRoute(route).pattern
            .replace(":facilityOrderId", facilityOrder.id)
            .replace(":pickTicketHeaderId", pickTicketHeaderId)}`);
    }

    @mobxAction.bound
    async downloadDeliveryTicketNiko(facilityOrderId) {
        const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
        const result = await pickTicketHeaderService.hasPickTicketItemsNiko(facilityOrderId, 'Delivery Ticket');
        if (!result.hasItems) {
            this.rootStore.notificationStore.error("There are no items to include on the Delivery Ticket.");
            return;
        }
        const url = `${pickTicketHeaderService.getDeliveryReportDownloadUrlNiko(facilityOrderId)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(url);
    }

    @mobxAction.bound
    async callFunc() {
        this.fetchFunc(this.call).then(v => {this.tasks = v});
    }

    @mobxAction.bound
    async onChange() {
        this.disableCheckboxes = true;
        await this.action.onChange(...arguments);
        await setTimeout(() => {this.disableCheckboxes = false}, 1000);
    }

    async setReminder(){
        if(this.userRoles.includes("IntakeSpecialist"))
        {
            this.reminder = "isReminderIntake";
        }
        else if(this.userRoles.includes("PayorSpecialist"))
        {
            this.reminder = "isReminderPayor";
        }
        else if(this.userRoles.includes("DocumentSpecialist"))
        {
            this.reminder = "isReminderDocument";
        }
        else if(this.userRoles.includes("Biller"))
        {
            this.reminder = "isReminderBiller";
        }
    }
}

export default TasksCardStore;
